import { render, staticRenderFns } from "./Help-User.vue?vue&type=template&id=c9854c70&scoped=true&"
import script from "./Help-User.vue?vue&type=script&lang=js&"
export * from "./Help-User.vue?vue&type=script&lang=js&"
import style0 from "./Help-User.vue?vue&type=style&index=0&id=c9854c70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9854c70",
  null
  
)

export default component.exports